import { get, post, put, remove } from "../../ApiService";
import { ApiUrl } from "../../ApiUrl";
import { GetCountryUomListParams, CountryUomType } from "./types";

export const getCountryUomList = async (
  params: GetCountryUomListParams,
  region: number
) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());
    if (params.orderBy)
      queryParams.append("order_by", params.orderBy.toString());
    if (params.search) queryParams.append("search", params.search);
    if (params.country) queryParams.append("country", params.country);
    const url = `${ApiUrl.CountryUomModule.getCountryUom}?region=${region}&${queryParams.toString()}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const createCountryUom = async (
  data: CountryUomType,
  region: number
) => {
  try {
    const url = `${ApiUrl.CountryUomModule.postCountryUom}?region=${region}`;
    const res = await post(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateCountryUom = async (
  id: number,
  data: CountryUomType,
  region: number
) => {
  try {
    const url = `${ApiUrl.CountryUomModule.updateCountryUom(
      id
    )}?region=${region}`;
    const res = await put(url, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteCountryUom = async (id: number, region: number) => {
  try {
    const url = `${ApiUrl.CountryUomModule.deleteCountryUom(
      id
    )}?region=${region}`;
    const res = await remove(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getCountryList = async (region: number) => {
  try {
    const url = `${ApiUrl.CountryUomModule.countryList}?region=${region}`;
    const res = await get(url);
    return res;
  } catch (error: any) {
    return error.response;
  }
}